export const siteConfigurations = {
    footer_first: 'footer_first',
    footer_second: 'footer_second',
    footer_third: 'footer_third',
    header_last: 'header_last',
};

export const locationDocuments = {
    main_top_bar_document: 'main_top_bar_document',
};